// Vereinsbereich › Mitteilungen an DIESEN Verein (23.10.2026).
//
// Bis dahin gab es für Vereine keine Benachrichtigung in der Anwendung: die
// Ankündigungen (routes/ankuendigungen.js) sah nur das Admin-Dashboard, ein
// Vereinskonto wird von dort nach /verein geleitet. Hier stehen nur
// Mitteilungen mit Empfänger (ankuendigungen.vereins_id), etwa „Starter X
// wurde von Klasse A nach B umgesetzt“ aus dem Zusammenlegen von Klassen.
// Ankündigungen an alle erscheinen hier bewusst nicht.
import React, { useCallback, useEffect, useState } from 'react';

export default function Mitteilungen({ token }) {
  // Nur das Token als Abhängigkeit: ein Kopf-Objekt aus dem Elternteil wäre
  // bei jedem Rendern neu und würde endlos nachladen.
  const kopf = useCallback(() => ({ Authorization: `Bearer ${token}` }), [token]);
  const [liste, setListe] = useState([]);
  const [alteZeigen, setAlteZeigen] = useState(false);
  const [fehler, setFehler] = useState('');

  const laden = useCallback(async () => {
    try {
      const r = await fetch('/api/ankuendigungen/meine', { headers: kopf() });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.success) throw new Error(d.error || `Fehler ${r.status}`);
      setListe(d.data || []);
      setFehler('');
    } catch (e) {
      setFehler(e.message);
    }
  }, [kopf]);
  useEffect(() => { laden(); }, [laden]);

  const gelesen = async (m) => {
    try {
      const r = await fetch(`/api/ankuendigungen/${m.id}/gelesen`, { method: 'POST', headers: kopf() });
      if (!r.ok) throw new Error(`Fehler ${r.status}`);
      setListe((l) => l.map((x) => (x.id === m.id ? { ...x, gelesen: 1 } : x)));
    } catch (e) {
      setFehler(`Konnte nicht als gelesen markiert werden: ${e.message}`);
    }
  };

  const neu = liste.filter((m) => !m.gelesen);
  const alt = liste.filter((m) => m.gelesen);
  if (!neu.length && !alt.length && !fehler) return null;
  const sicht = alteZeigen ? liste : neu;

  return (
    <section className="vd-mitteilungen" aria-label="Mitteilungen an euren Verein">
      <div className="vd-mt-kopf">
        <h3>Mitteilungen{neu.length > 0 && <span className="vd-mt-zahl">{neu.length} neu</span>}</h3>
        {alt.length > 0 && (
          <button className="vd-btn vd-btn--ghost vd-btn--sm" onClick={() => setAlteZeigen(!alteZeigen)} aria-expanded={alteZeigen}>
            {alteZeigen ? 'Gelesene ausblenden' : `Gelesene zeigen (${alt.length})`}
          </button>
        )}
      </div>
      {fehler && <p className="vd-mt-fehler" role="alert">{fehler}</p>}
      {sicht.map((m) => (
        <article key={m.id} className={`vd-mt${m.gelesen ? ' vd-mt--gelesen' : ''}`}>
          <div className="vd-mt-titel">
            <strong>{m.titel}</strong>
            <small>{m.erstellt_text}</small>
          </div>
          <p className="vd-mt-text">{m.inhalt}</p>
          {!m.gelesen && <button className="vd-btn vd-btn--gold vd-btn--sm" onClick={() => gelesen(m)}>Gelesen</button>}
        </article>
      ))}
    </section>
  );
}
